import { useEffect,useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { authEvents$ } from "../API/AxiosInstance";
import { deleteDeviceToken } from "../utils/deviceTokenDelete";

const AppLogout = ({ children }) => {

  const {
      user,
      logout
    } = useAuth0();

  const timerRef = useRef(null);

  const invalidateSession = async() => {
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}users/${user?.sub_id}/sessions/invalidate`, {}, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}})

    } catch(error) {
      console.log("invalidateSession error ",error)
    }
}

  const logoutAfterTokenExpired = async() => {
      try {
        await axios.get(`${process.env.REACT_APP_BASE_URL}oauth/logout`, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}})
        
      } catch(error) {
        console.log("logoutAfterTokenExpired error ",error)
      }
  }

  // logout function
  const handleLogout = async() => {
    await deleteDeviceToken()
    authEvents$.next({ type: '401' });
    setTimeout(async() => {
    await invalidateSession()
    await logoutAfterTokenExpired()
    localStorage.clear();
    localStorage.setItem('logout', true);
    logout({ logoutParams: { returnTo: window.location.origin } })
    console.log("trtrtrrtrlog")
    },5000)
  };

  // reset inactivity timer
  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      handleLogout();
    }, 30 * 60 * 1000); 
    // }, 10000); 
  };

  useEffect(() => {
    const events = [  "load","mousemove","mousedown","click","scroll","keydown", ];

    events.forEach((event) => {
        console.log("nananan ",event)
      window.addEventListener(event, resetTimer);
    });

    // Start timer on mount
    resetTimer();

    // Cleanup
    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);



  return children;
};
export default AppLogout;
